<template>
    <div class="form-con">
        <h1>注册</h1>
        <div class="signcon">
            <el-form  :model="form" ref="form">  
                <el-form-item prop="extmobile"  :rules="[{ required: true, message: '请输入手机号'},{ validator: checkAge, trigger: 'blur'}]">
                    <el-input type="text" v-model="form.extmobile" class="mobile"  placeholder="请输入手机号">
                        <span slot="prefix" class="el-input__icon mobile-icon">
                            +86<i class="el-icon-arrow-down"></i>
                        </span>
                    </el-input>
                </el-form-item>
                <el-form-item prop="validatecode"  :rules="{ required: true, message: '请输入验证码'}">
                    <el-input type="text" v-model="form.validatecode" class="yzcode" placeholder="请输入验证码">                
                        <span @click="getYzm()" slot="suffix"  class="yzcode-r" :loading="loadingController" :disabled="inputDisabled" :style="{'pointer-events':inputDisabled}">
                            {{text}}
                        </span>
                    </el-input>
                </el-form-item>
                <el-form-item prop="extpwd"  :rules="{ required: true, message: '请输入密码'}">
                    <el-input placeholder="请输入密码" v-model="form.extpwd" show-password></el-input>
                </el-form-item>
                <el-form-item prop="checkpwd"  :rules="[{ required: true, message: '请确认密码'},{validator: validator, trigger: 'blur'}]">
                    <el-input placeholder="请输入密码" v-model="form.checkpwd" show-password></el-input>
                </el-form-item>
                <div class="zcxieyi">
                    <el-checkbox v-model="checked"></el-checkbox>
                    我已阅读并接受<span class="xieyi">用户协议</span>和<span class="xieyi">隐私政策</span>
                </div>
            </el-form>
        </div>
        <div class="btn-action-row">
            <a @click="submitHandler('form')">注册</a>
        </div>
        <div class="sign-bottom">
            已有账号，<a href="/login">马上登录</a>
        </div>
    </div>
</template>

<script>

export default {
    head: {
        title: '注册'
    },
    layout: 'login',
    data() {
        var that = this;
        return {
            loadingController:false,
            inputDisabled:'auto',
            visible:false,
            mobilehead:'+86',
            text:'发送验证码',
            form:{
                extmobile:'',
                extpwd:'',
                checkpwd:'',
                validatecode:''              
            },
            checked:false
        }
    },
    methods: {
        checkAge (rule, value, callback) {
            if(!/^[1][0-9]{10}$/.test(value)){
                callback(new Error('请输入正确的手机号'));
            }       
            callback();
        },
        validator(rule, value, callback) {
            if(value!==''){
                if(this.form.extpwd !== this.form.checkpwd) {
                    callback(new Error('密码与确认密码不一致'));
                }
            }
            callback();
        },
        getYzm() {
            if(!this.form.extmobile ||  !/^[1][0-9]{10}$/.test(this.form.extmobile)) {
                ShowMsg('请确认手机号', 'warning');
                return;
            };
            this.$post(`${this.$store.state.api.sysUrl}/user/sendyzm.json`, {
                phonenum: this.form.extmobile
            }, data => {
                //倒计时
                this.loadingController = true;
                this.inputDisabled = 'none';
                //倒计时
                var remain = 60;
                this.text = '请在' + remain + 's后重试'

                var int = setInterval(() => {
                    if (remain != 0) {
                        remain--
                        this.text = '请在' + remain + 's后重试'
                    } else {
                        clearInterval(int);
                        this.text = '发送验证码';
                        this.inputDisabled = 'auto';
                        this.loadingController = false;
                    }
                }, 1000)
            })
        },
        submitHandler(form) {
            this.$refs[form].validate((valid)=> {
                if (valid) {
                    if(!this.checked){
                        ShowMsg('请勾选用户协议和隐私政策');
                    }else{
                        this.$post(`${this.$store.state.api.sysUrl}/user/reg.json`,this.form, function (data, res) {
                            ShowMsgBox(res.msg);
                            this.goto('/login');
                        });
                    }
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    .form-con{
        width: 100%;
        font-family: Microsoft YaHei;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        padding-bottom:22px;
        & input::-webkit-input-placeholder {
            color: #d1d1d2;
        }
        .signcon{
            width:386px;
            margin:0 auto;
            position: relative;
            .dwscroll{
                cursor: pointer;
                border-radius: 50%;
                width:20px;
                height:20px;
                line-height:17px;
                border:1px solid #333333;
                text-align: center;
                position:fixed;
                bottom:205px;
                right:10px;
            }
            .mobile{
                ::v-deep {
                    .el-input__inner{
                        padding-left:70px;
                    }
                }
                .mobile-icon{
                    color:#999999;
                    cursor: pointer;
                    display:block;
                    i{
                        margin-left:5px;
                        display: inline;
                    }
                }
            }

            .yzcode{
                .yzcode-r{
                    width: 108px;
                    height:40px;
                    line-height:40px;
                    float: left;
                    cursor: pointer;
                    font-size: 14px;
                    color: #4988cf;
                }
            }

        }
        .zcxieyi{
            width: 386px;
            height:19px;
            margin:0 auto;
            margin-top:12px;
            color: #d1d1d2;
            .xieyi{
                margin:0 3px;
                cursor: pointer;
                color: #FFB73B;
                font-size: 14px;
            }
            .xieyi:hover{
                color:#4988CF;
            }
        }
        h1{
            width: 100%;
            height:75px;
            line-height:75px;
            color: #4988cf;
            font-size: 22px;
            text-align: center;
            border-bottom: 1px solid #e9e9e9;
            margin-bottom: 20px;
        }
        .sign-bottom{
            width: 144px;
            height:21px;
            margin:0 auto;
            margin-top:22px;
            font-size: 16px;
            a{
                cursor: pointer;
                color: #FFB73B;
            }
            a:hover{
                color:#4988CF;
            }
        }
        .action-row{
            margin-bottom: 30px;
            overflow: hidden;

            a{
                float: right;
                color: #ffb534;
            }
        }

        .btn-action-row{
            margin:0 auto;
            margin-top: 18px;
            width: 386px;
            height: 62px;
            background-color: #4988cf;
            border-radius: 4px;
            a{
                display: block;
                width:100%;
                height:100%;
                font-size: 22px;              
                text-align: center;
                line-height:62px;
                color: #ffffff;
            }
        }

        

        .btn-submit{
            font-size: 18px;
            height:54px;
        }

        ::v-deep .btn-row{
            margin-bottom: 0;
        }
    }
</style>